import type { IconData } from '@stacksjs/iconify-core'

export const arrowLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M311 630L0 319L311 8l65 66l-245 245l245 245z\"/>",
  "width": 380,
  "height": 790,
  "viewBox": "0 0 380 790"
}

export default arrowLeft
